import React from "react";

function TowK22() {
  return <div>2022</div>;
}

export default TowK22;
